import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { catchError, Observable, throwError } from "rxjs";
import { environment } from "src/environments/environment";
import { Utils } from "src/app/utils/utils";

@Injectable({providedIn: "root"})
export class ContractBundleListService {
    private readonly apiUrl: string;

    constructor(private readonly httpClient: HttpClient) 
    {
        this.apiUrl = `${environment.endpoint}api/countrybackend/contractbundle`;
    }

    getContractBundleTranslations(): Observable<ContractBundleLocalTranslation[]> {
        return this.httpClient.get<ContractBundleLocalTranslation[]>(`${this.apiUrl}/translations`).pipe(
            catchError(error => {
                Utils.writeLog(this.httpClient, `${this.apiUrl}/translations`, error);
                return throwError(() => error);
            })
        );
    }

    getContractBundleTranslationAudit(bundleId: number): Observable<ContractBundleTranslationAudit[]> {
        return this.httpClient.get<ContractBundleTranslationAudit[]>(`${this.apiUrl}/translations/audit/${bundleId}`).pipe(
            catchError(error => {
                Utils.writeLog(this.httpClient, `${this.apiUrl}/translations/audit/${bundleId}`, error);
                return throwError(() => error);
            })
        );
    }


    updateContractBundleTranslation(model: ContractBundleLocalTranslationUpdate): Observable<any> {
        return this.httpClient.put<any>(`${this.apiUrl}/translations`, model).pipe(
            catchError(error => {
                Utils.writeLog(this.httpClient, `${this.apiUrl}/translations`, error);
                return throwError(() => error);
            })
        );
    }

}